<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="showModal = true" id="show-modal"></v-btn>
  </v-row>

  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <table class="quotes-table">
            <thead>
              <tr>
                <th class="table-heading-text" style="width: 80%">quote</th>
                <th class="table-heading-text text-right" style="width: 20%">author</th>
              </tr>
            </thead>
            <tbody>
              <tr class="remove-bottom-border" v-for="quote in quotes" :key="quote.id" @click="showEditModal(quote)">
                <td class="table-content-text text-left quote-cell">{{ quote.quote_text }}</td>
                <td class="table-content-text text-right author-cell">{{ quote.author }}</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals-->
  <InvestorQuoteModalPopup :show="showModal" :currentRow="selectedRow" @close="closeModal"></InvestorQuoteModalPopup>

</template>

<script>
import axios from 'axios';
import InvestorQuoteModalPopup from './modals/InvestorQuoteModalPopup.vue';
import { mapState, mapMutations} from 'vuex';

export default {
  components: {
    InvestorQuoteModalPopup
  },
  data() {
    return {
      quotes: [],
      showModal: false,
      selectedRow: {}
    };
  },
  async created() {
    this.getQuotes();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'investor quotes',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    showEditModal(row){
     this.selectedRow = row;
     this.showModal = true;
    },
    closeModal(){
      this.showModal = false;
      this.selectedRow = {};
    },
    async getQuotes(){
      try {
      const response = await axios.get("/quotes/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.quotes = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load quotes' });
      }
    }
  }
};
</script>


<style scoped>

.quotes-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

.quotes-table tr {
  cursor: pointer;
}

.quotes-table th,
.quotes-table td {
  padding: 0 16px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.quotes-table th {
  height: 52px;
  vertical-align: middle;
}

.quotes-table td {
  height: 48px;
  padding-top: 16px;
  padding-bottom: 16px;
  vertical-align: middle;
}

.quotes-table tbody tr:hover {
  background: rgba(0, 0, 0, 0.04);
}

.table-heading-text{
  font-size: 1.5rem;
  font-weight: 300 !important;
}

.table-content-text{
  font-size: 1.05rem;
  font-weight: 300 !important;
}

.remove-bottom-border td{
  border-bottom: none !important;
}

.quote-cell {
  white-space: normal;
  word-break: break-word;
}

.author-cell {
  white-space: nowrap;
}

</style>
